// loginRegisterConstants.js
'use strict';

export const Entry = {
  LOGIN: 'login',
  REGISTER: 'register',
};

export const USERNAME_LIMIT = 20;

export const OTP_CODE_LENGTH = 6;

export const AuthId = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  GOOGLE: 'google-oauth2',
  APPLE: 'apple',
  APPLE_ID: 'apple-id',
  APPLE_ID_NEW: 'apple-3AX6Y553BQ',
  PASSWORD: 'password',
  EMAIL: 'email',
  SMS: 'sms',
  EMAIL_SMS: 'email-sms',
  DISCORD: 'discord',
  EMAIL_UNVERIFIED: 'email-unverified',
  PHONE_NUMBER: 'phone-number',
  WEB_AUTHN: 'webauthn',
};
